module.exports = __webpack_public_path__ + "static/img/indexSoftware2.54c735c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexSoftware2.png
// module id = R6E7
// module chunks = 2